const vuetifyTheme = {
  primary: "#F58634",
  secondary: "#61696B",
  accent: "#ED3237"
};

const menu = [
  {
    path: "/",
    name: "Início",
    icon: "fas fa-home"
  },
  {
    path: "/produtos",
    name: "Produtos",
    icon: "fas fa-shopping-cart"
  },
  {
    path: "/lojas",
    name: "Lojas",
    icon: "fas fa-building"
  },
  {
    path: "/marcas-parceiras",
    name: "Marcas Parceiras",
    icon: "fas fa-tag"
  },
  {
    path: "/contato",
    name: "Contato",
    icon: "fas fa-user"
  },
  {
    path: "/trabalhe-conosco",
    name: "Trabalhe Conosco",
    icon: "fas fa-briefcase"
  }
];

export { vuetifyTheme, menu };
